import { InputNumber, Typography } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MoneyInput = function MoneyInput(_ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      isReadonly = _ref.isReadonly,
      emptyMessage = _ref.emptyMessage,
      _onChange = _ref.onChange;

  if (isReadonly) {
    if (value === undefined) {
      return /*#__PURE__*/_jsx(EmptyText, {
        className: "empty",
        children: emptyMessage
      });
    }

    return /*#__PURE__*/_jsxs(Typography.Text, {
      children: [value.amount, "\u20AC"]
    });
  }

  return /*#__PURE__*/_jsx(Container, {
    value: value === null || value === void 0 ? void 0 : value.amount,
    min: 0,
    precision: 2,
    placeholder: placeholder,
    addonAfter: "\u20AC",
    readOnly: isReadonly,
    bordered: !isReadonly,
    onChange: function onChange(newValue) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange({
        amount: newValue
      });
    }
  });
}; // Styles

var Container = styled(InputNumber).withConfig({
  displayName: "MoneyInput__Container",
  componentId: "sc-1uvkcux-0"
})(["width:100%;.ant-typography.empty{color:rgba(0,0,0,0.25) !important;}"]);
var EmptyText = styled(Typography.Text).withConfig({
  displayName: "MoneyInput__EmptyText",
  componentId: "sc-1uvkcux-1"
})(["color:rgba(0,0,0,0.25) !important;font-size:14px;"]);